module.exports = __webpack_public_path__ + "img/woman-in-white-long-sleeved-dress-1030895.dd84d30a.jpg";